module.exports = __webpack_public_path__ + "img/heart_green.c82b9ace.png";